import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router';

import { MiniAppRoutes } from '@/config/appRoutes';
import { extractTimelySearchParams, saveCurrentSearchParams } from '../helpers';
import { OAUTH_REDIRECT_VALIDATION_TIME, SIGN_OUT_REDIRECT_VALIDATION_TIME } from '../constants';
import { caseInsensitiveUrlParam } from '@/components/utils';

const useURLLinkId = (
    onReceiveLinkId: (linkId: string) => void,
): void => {
    const navigate = useNavigate();
    // TODO: migrate on useSearchParams
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        let linkId = caseInsensitiveUrlParam(urlParams, 'linkid');
        if (linkId) {
            saveCurrentSearchParams(location.search);
        } else {
            const isOauthRedirect = urlParams.has('error_description') || urlParams.has('code');
            const savedSearch = extractTimelySearchParams(isOauthRedirect
                ? OAUTH_REDIRECT_VALIDATION_TIME
                : SIGN_OUT_REDIRECT_VALIDATION_TIME);
            const savedSearchURL = new URLSearchParams(savedSearch);
            linkId = caseInsensitiveUrlParam(savedSearchURL, 'linkid');
            navigate(`${MiniAppRoutes.sharedFile}${savedSearch}`, { replace: true });
        }
        onReceiveLinkId(linkId);
    }, []);
};

export default useURLLinkId;
